import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  HeartHandshake,
  Stethoscope,
  ClipboardCheck,
  Menu,
  X,
} from "lucide-react";

import logo from "./Assets/cube.jpeg";

const Sidebar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isExpanded, setIsExpanded] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      id: "sexual",
      icon: HeartHandshake,
      label: "Sexual Health",
      path: "/sexual-health",
    },
    {
      id: "therapy-tool",
      icon: Stethoscope,
      label: "Therapy Tools",
      path: "/therapy-tool",
    },
    {
      id: "self-assessments",
      icon: ClipboardCheck,
      label: "Self-Assessments",
      path: "/self-assessment",
    },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMobileMenuOpen(false);
  };

  const isActive = (path) => location.pathname === path;

  return (
    <>
      <div className="md:hidden fixed top-0 left-0 right-0 bg-white z-50 border-b border-gray-200 h-16 px-4 shadow-sm">
        <div className="h-full flex items-center justify-between">
          <button
            onClick={() => setIsMobileMenuOpen(true)}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <Menu size={20} />
          </button>
          <button
            onClick={() => handleNavigation('/')}
            className="font-semibold text-lg text-gray-900 hover:bg-gray-50 px-3 py-2 rounded-lg transition-colors"
          >
            WellnessAI
          </button>
          <div></div>
        </div>
      </div>

      <div
        className={`
        fixed inset-y-0 left-0 bg-white border-r border-gray-200 z-40
        transform transition-all duration-300 ease-in-out md:translate-x-0 flex flex-col
        ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full"}
        ${isExpanded ? "w-64" : "w-16"}
      `}
      >
        <div className="h-16 px-4 flex items-center justify-between border-b border-gray-200">
          <button 
            onClick={() => handleNavigation('/')}
            className="flex items-center space-x-3 hover:bg-gray-50 rounded-lg p-2 -ml-2 transition-colors"
          >
            <img
              src={logo}
              alt="CubeCover Logo"
              className="h-8 w-8 rounded-full object-cover"
            />
            {isExpanded && (
              <span className="font-bold text-xl text-gray-900">
                WellnessAI
              </span>
            )}
          </button>
          <div className="flex items-center space-x-2">
            <button
              onClick={() => setIsExpanded(!isExpanded)}
              className="hidden md:block p-1 hover:bg-gray-100 rounded transition-colors"
              title={isExpanded ? "Collapse sidebar" : "Expand sidebar"}
            >
              <Menu size={20} />
            </button>
            <button
              onClick={() => setIsMobileMenuOpen(false)}
              className="md:hidden p-1 hover:bg-gray-100 rounded transition-colors"
            >
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <nav className="space-y-2">
            {menuItems.map((item) => (
              <div key={item.id} className="relative group">
                <button
                  onClick={() => handleNavigation(item.path)}
                  className={`w-full flex items-center px-3 py-2.5 rounded-lg text-left transition-colors ${
                    isActive(item.path)
                      ? "bg-blue-50 text-blue-700 border-r-2 border-blue-600"
                      : "text-gray-700 hover:bg-gray-50"
                  } ${!isExpanded ? "justify-center" : ""}`}
                  title={!isExpanded ? item.label : ""}
                >
                  <item.icon
                    size={20}
                    className={`${isExpanded ? "mr-3" : ""} ${
                      isActive(item.path) ? "text-blue-600" : "text-gray-500"
                    }`}
                  />
                  {isExpanded && (
                    <span className="font-medium">{item.label}</span>
                  )}
                </button>

                {!isExpanded && (
                  <div className="absolute left-full top-1/2 transform -translate-y-1/2 ml-2 px-2 py-1 bg-gray-800 text-white text-sm rounded opacity-0 group-hover:opacity-100 transition-opacity z-50 whitespace-nowrap pointer-events-none">
                    {item.label}
                  </div>
                )}
              </div>
            ))}
          </nav>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/20 z-30"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}
    </>
  );
};

export default Sidebar;
